import APIService from '@/services/APIService';

export default {
  createTask(data) {
    return APIService.post('/tasks', data);
  },
  updateTask(data) {
    return APIService.put(`/tasks/${data.id}`, data);
  },
  getTask(id, data) {
    return APIService.get(`/tasks/${id}`, { params: data });
  },
  getTaskForPass(id, params) {
    return APIService.get(`/task/${id}/for-passing`, { params });
  },
  getTaskList(params) {
    return APIService.get('/tasks', { params });
  },
  attachTask(id, data) {
    return APIService.post(`/task/${id}/relation`, data);
  },
  detachTask(id, data) {
    return APIService.post(`/task/${id}/relation-detach`, data);
  },
  saveAnswers(id, data) {
    return APIService.post(`/task/${id}/make-answers`, data);
  },
  getTaskUserList(taskId, groupIds) {
    return APIService.get(`/task/${taskId}/users`, { params: { groups: groupIds } });
  },
  getTaskAnswers(taskId, groupId, userId) {
    const data = {
      user: userId,
      group: groupId,
    };
    return APIService.post(`/task/${taskId}/user-answers`, data);
  },
  getTaskListForGroup(groupId) {
    return APIService.get(`/groups/${groupId}/tasks`);
  },
  getTaskListForUser(groupId) {
    return APIService.get(`/groups/${groupId}/tasks/user`);
  },

  // Отметки
  addMark(data) {
    return APIService.post('/mark/add', data);
  },
  updateMark(id, data) {
    return APIService.put(`/mark/${id}`, data);
  },
  getMark(groupId, taskId, userId) {
    return APIService.get(`/mark/group/${groupId}/task/${taskId}/user/${userId}`);
  },

  // Метки (теги)
  unbindTags(taskId, data) {
    return APIService.post(`/task/${taskId}/tags/unbinding`, data);
  },

  // // Шаблоны заданий
  // getTemplateList(data) {
  //   return APIService.get('/task/template', data);
  // },
  // getTemplate(templateId, data) {
  //   return APIService.get(`/task/template/${templateId}`, data);
  // },
  // updateTemplate(templateId, data) {
  //   return APIService.put(`/task/template/${templateId}`, data);
  // },
  // createTemplate(data) {
  //   return APIService.post('/task/template', data);
  // },

  cloneTask(id, params) {
    return APIService.post(`/tasks/${id}/clone`, params);
  },

  // Черновики заданий
  getDraft(data) {
    return APIService.get('/task/drafts', { params: data });
  },
  createDraft(data) {
    return APIService.post('/task/draft', data);
  },
  updateDraft(id, data) {
    return APIService.put(`/task/draft/${id}`, data);
  },
  deleteDraft(id) {
    return APIService.delete(`/task/draft/${id}`);
  },
  getDrafts(id) {
    return APIService.get(`/task/draft/${id}`);
  },

  // getTaskListForCheck(params) {
  //   return APIService.get('/journal-answer', { params });
  // },
  // getUserTaskListForCheck(id, groupId, params) {
  //   return APIService.get(`/learners/${id}/group/${groupId}/tasks`, { params });
  // },

  startReCalculate(id) {
    return APIService.post(`/task/${id}/recalculate`);
  },

  /**
   * Tasks statistics
   */
  // taskStatistics(params) {
  //   return APIService.get('/task-statistics', { params });
  // },
  courseTaskStatistics(id, params) {
    return APIService.get(`/analytics/tasks/courses/${id}`, { params });
  },
  courseUnitTaskStatistics(id, unitId, params) {
    return APIService.get(`/analytics/tasks/courses/${id}/course-units/${unitId}`, { params });
  },
  lessonTaskStatistics(id, unitId, lessonId, params) {
    return APIService.get(`/analytics/tasks/courses/${id}/course-units/${unitId}/lessons/${lessonId}`, { params });
  },
  taskStatistics(params) {
    return APIService.get('/analytics/tasks', { params });
  },
  tasksStatisticsShow(id, params) {
    return APIService.get(`/task-statistics/${id}`, { params });
  },
};
